import './FarmWitch.css';

const FarmWitch = () =>
{
    return (
        <section id = "farmwitch">
            <div className="container">
                <div className= "row">
                    <div className= "col">
                    <br/>
                    <h1>Farm Witch</h1>
                        <div className="mt-5">
                            <img src="PersonalImages/Tiles/farmwitch-cover.gif" className="center-block" alt="..."/>
                        </div> 
                    </div>
                </div>
                <div className= "row">
                    <div className= "col my-4">
                        <div className= "font-weight-bold"><b>Description:</b> </div>
                            A game where you must protect your plants from all sorts of evil trying to take it away. You have magic in order
                            to help protect you. Some of the magic includes various types of magic missiles and a magic sword. Are you able to 
                            survive and harvest all your plants? The current playable version of the game is an old but working build, the current 
                            build is not playable as it is being updated to the new version of Game Maker Studio 2.
                    </div>
                </div>
                <div className= "row">
                    <div className= "col mb-4">
                        <img src="PersonalImages/Projects/farmwitch-combat.gif" className= "center-block" alt="..."/>
                        <div className= "spacer"></div>
                            <div className= "font-weight-bold"><b>Controls:</b></div>
                            <li>Movement: WASD</li>
                            <li>Change HotBar: Q</li>
                            <li>Inventory: E</li>
                            <li>Use Item/Magic: Left Mouse Button</li>
                            <li>Options: Escape</li>
                            <div className= "spacer"></div>
                            <a href="https://drive.google.com/drive/folders/1VxiSA6FBjxra1CcbE0UTr1zy2VRCcFug?usp=sharing" className= "btn btn-primary" target="_blank" rel="noreferrer">Download Game</a>
                            <div className= "spacer"></div>
                    </div>
                </div>
                <div className= "row">
                    <div className= "col my-4">
                        <img src="PersonalImages/Projects/farmwitch-plant.gif" className= "center-block text-center" alt="..."/>
                        <div className= "spacer"></div>
                        <div className= "font-weight-bold"><b>Development:</b></div>
                        This game is still in development, and the first pre alpha is scheduled to be release shortly. I am developing it with Sam Allen. Development has been
                        done quite slowly over 2 years, with more stuff being added when ever we both have free time to add more to it. It is written in Game Maker studio 2.
                        So far there have been difficulties in development with getting some features to work as intended, one of which recently being getting surface shaders 
                        to draw over a certain portion of the screen. This has now been solved and has allowed for the ability to use any shader over certain parts of the screen.
                        The planting feature also went through many iterations, starting with a basic slow planting feature, this has now been changed so it is possible to quickly
                        plant many plants at once with effects as you throw the seed to the tile it is being planted on.
                        <div className= "spacer"></div>
                        <a href="https://drive.google.com/drive/folders/1dZuoZOWX0O6vchksrPTBH0aR18y6FJ9i?usp=sharing" className= "btn btn-primary" target="_blank" rel="noreferrer">View Code</a>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default FarmWitch;